define.alias("ember-concurrency/helpers/cancel-all", "media/helpers/cancel-all");